import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Send Contact Us form
export const Create = createAsyncThunk(
  "/contactUs",
  async (payload, { rejectWithValue }) => {
    try {
      const { name, email, mobile_no,alternate_no,message } = payload;
      console.log("name",name)


     const query = `?name=${name}&email=${email}&mobile_no=${mobile_no}&alternate_no=${alternate_no}&message=${message}`;

      const res = await POST(`${APIS.ContactUs.Contact_Us}${query}`);
      console.log("Ressssssssssssss",res);
      
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "contact",
  initialState: {
    data: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetContactState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = Slice.actions;
export default Slice.reducer;


